import { VStack } from '@/package';

import { MyWorkFlowPerformance } from './MyWorkFlowPerformance';
import { MyWorkProjectPeriodLabeledObject } from './MyWorkProjectPeriodLabeledObject';
import { MyWorkProjectStatisticSummary } from './MyWorkProjectStatisticSummary';

const MyWorkProjectStatistics = () => {
  return (
    <VStack gap={1.5} className="h-full w-full overflow-y-auto bg-white p-4">
      <MyWorkProjectStatisticSummary />
      <MyWorkFlowPerformance />
      <MyWorkProjectPeriodLabeledObject />
    </VStack>
  );
};

export default MyWorkProjectStatistics;
